import { Action, handleActions } from 'redux-actions'
import { resetUploadedFileDto, uploadImageFail, uploadImageSuccess } from './UploadActions'
import { FileDto } from '../../../services/api.types'

class State {
  uploadedFileDto: FileDto | null = null
  lastFileUploadFail: number | null = null
}

export const upload = handleActions<State, any>(
  {
    [String(resetUploadedFileDto)]: (state: State): State => ({
      ...state,
      uploadedFileDto: null,
    }),
    [String(uploadImageSuccess)]: (state: State, action: Action<FileDto>): State => ({
      ...state,
      uploadedFileDto: action.payload,
    }),
    [String(uploadImageFail)]: (state: State, action: Action<number>): State => ({
      ...state,
      lastFileUploadFail: action.payload,
    }),
  },
  new State(),
)

export { State as UploadState }
